import { Wrench, Zap, Cpu, Cog, Building2 } from "lucide-react";

export const EMAIL = "solucaosrf.pr@gmail.com";
export const PHONE = "933 696 401";
export const PHONE_TEL = "+351933696401";

export const NAV = [
  { id: "quem-somos", label: "Quem somos" },
  { id: "trabalhos", label: "Trabalhos" },
  { id: "servicos", label: "Serviços" },
  { id: "contacto", label: "Contacto" },
];

export const SERVICES = [
  { icon: Wrench, title: "Manutenção industrial e assistência técnica", text: "Apoio na identificação de avarias e manutenção de instalações e equipamentos." },
  { icon: Zap, title: "Instalações e reparações elétricas", text: "Execução de trabalhos elétricos, deteção de falhas e resolução de problemas." },
  { icon: Cpu, title: "Quadros elétricos e automação industrial", text: "Montagem, organização, verificação e apoio técnico em quadros e sistemas de comando." },
  { icon: Cog, title: "Manutenção de máquinas e equipamentos", text: "Inspeção e intervenção técnica para ajudar a reduzir paragens e falhas." },
  { icon: Building2, title: "Instalações em edifícios e remodelações", text: "Instalações elétricas em obras, remodelações e melhorias de espaços." },
];

export const AUDIENCE = ["Empresas", "Indústria", "Comércio", "Condomínios", "Particulares"];

export const WORKS = [
  { id: "p4", tag: "Quadros elétricos", title: "Quadro elétrico de distribuição", text: "Montagem e organização de quadro elétrico com proteções diferenciais e circuitos identificados." },
  { id: "p3", tag: "Comércio", title: "Loja com equipamentos de frio", text: "Instalação elétrica e iluminação para espaço comercial com vitrinas frigoríficas." },
  { id: "p2", tag: "Máquinas e equipamentos", title: "Casa de máquinas de piscina", text: "Quadro de comando, ligações e apoio técnico ao sistema de filtragem e bombagem." },
  { id: "p1", tag: "Remodelações", title: "Mural com iluminação", text: "Iluminação LED integrada para valorizar um mural pintado em obra de remodelação." },
];
